// @ts-nocheck
import { createAsyncActionTypes } from '../../../core/store/actionCreators';

export const FETCH_ORDERS = 'order/fetchOrders';
export const {
  pending: FETCH_ORDERS_PENDING,
  fulfilled: FETCH_ORDERS_FULFILLED,
  rejected: FETCH_ORDERS_REJECTED,
} = createAsyncActionTypes(FETCH_ORDERS);

export const FETCH_ORDER = 'order/fetchOrder';
export const {
  pending: FETCH_ORDER_PENDING,
  fulfilled: FETCH_ORDER_FULFILLED,
  rejected: FETCH_ORDER_REJECTED,
} = createAsyncActionTypes(FETCH_ORDER);

export const REFUND_ORDER = 'order/refundOrder';
export const {
  pending: REFUND_ORDER_PENDING,
  fulfilled: REFUND_ORDER_FULFILLED,
  rejected: REFUND_ORDER_REJECTED,
} = createAsyncActionTypes(REFUND_ORDER);

export const CANCEL_ORDER = 'order/cancelOrder';
export const {
  pending: CANCEL_ORDER_PENDING,
  fulfilled: CANCEL_ORDER_FULFILLED,
  rejected: CANCEL_ORDER_REJECTED,
} = createAsyncActionTypes(CANCEL_ORDER);

export const DESELECT_ORDER = 'order/deselectOrder';
